import GeneralObjects from './GeneralObjects';

export default GeneralObjects;